import { createSinglePaymentHandler, registerPaymentHandler } from "./activeLoanPaymentHandler";
import { authenticationHandlers } from "./authenticationHandlers";
import { infrastructureHandlers } from "./infrastructureHandlers";
import { interestCalculatorHandler } from "./interestCalculatorHandler";
import { legalConsentHandlers } from "./legalConsentHandlers";
import { loanAppHandlers } from "./loanAppHandlers";
import { loansHandlers } from "./loansHandlers";

export const handlers = [
  ...authenticationHandlers,
  ...infrastructureHandlers,
  ...loanAppHandlers,
  ...legalConsentHandlers,
  ...loansHandlers,
  ...interestCalculatorHandler,
  ...createSinglePaymentHandler,
  ...registerPaymentHandler,
];
